import React, { useState } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { getOrgSlug } from '../lib/utils.js';
import CheckIcon from './icons/CheckIcon.jsx';
import DownArrowIcon from './icons/DownArrowIcon.jsx';
import ProfileIcon from './icons/Profilecon.jsx';
import { SignOutIcon } from './icons/SignOutIcon.jsx';
import { UserLink } from './links/index.jsx';

const SiteHeaderActionDropdown = ({ signOut, currentUser }) => {
  const slug = getOrgSlug();
  const [open, setOpen] = useState(false);

  if (!currentUser || !currentUser.organizations) {
    return null;
  }

  return (
    <DropdownButton
      noCaret
      id="id"
      bsStyle="info"
      style={{ backgroundColor: 'white', border: 'none', minWidth: '200px' }}
      className="component-bg-white"
      open={open}
      onToggle={(isOpen) => setOpen(isOpen)}
      title={
        <div className="flex">
          <div
            className="profile-avatar medium m-r-8"
            style={{ borderRadius: '7px' }}
          >
            <img src={currentUser.avatar} alt="user-avatar" />
          </div>
          <p className="m-b-0 m-r-8">{currentUser.fullName}</p>
          <DownArrowIcon color="#7F8FA4" />
        </div>
      }
    >
      <ul className="m-l-0" style={{ padding: '0px' }}>
        {currentUser.organizations.map((org) => (
          <React.Fragment key={org.id}>
            <li
              className="flex flex-align-center w-100"
              style={{ borderBottom: '1px solid #DFE2E5' }}
              onClick={() => {
                setOpen(false);
                window.location.href = `/${org.slug}/projects`;
              }}
            >
              <a
                role="button"
                style={{
                  display: 'flex',
                  width: '100%',
                  minWidth: '200px',
                  alignItems: 'center',
                  padding: '8px 8px',
                  height: '46px',
                }}
              >
                <div className="flex w-100">
                  <div className="profile-avatar medium m-r-10">
                    {org.icon ? <img src={org.icon} alt="org icon" /> : null}
                  </div>
                  <p className="m-b-0 m-r-38">{org.name}</p>
                </div>
                {org.slug === slug ? <CheckIcon /> : null}
              </a>
            </li>
          </React.Fragment>
        ))}
        <li
          style={{ borderBottom: '1px solid #DFE2E5' }}
          onClick={() => setOpen(false)}
        >
          <UserLink
            userId={currentUser.id}
            style={{
              display: 'flex',
              width: '100%',
              minWidth: '200px',
              alignItems: 'center',
              padding: '8px 8px 8px 12px',
              height: '46px',
            }}
          >
            <span className="flex">
              <ProfileIcon />
              <span>&nbsp; My Profile</span>
            </span>
          </UserLink>
        </li>
        <li
          onClick={() => {
            setOpen(false);
            signOut();
          }}
        >
          <a
            role="button"
            className="user-profile"
            style={{
              display: 'flex',
              width: '100%',
              minWidth: '200px',
              alignItems: 'center',
              padding: '8px 8px 8px 12px',
              height: '46px',
            }}
          >
            <span className="flex">
              <SignOutIcon />
              <span>&nbsp; Sign Out</span>
            </span>
          </a>
        </li>
      </ul>
    </DropdownButton>
  );
};

export default SiteHeaderActionDropdown;
